<template>
  <div class='pro-edit'>
    <div class='header' :class='{"back-primary":itemEditButton!==undefined}'>
      <!-- <button class='btn btn-dark' @click='confirmation()'>
        <span class='fas fa-arrow-left'></span> BACK</button> -->
      <span class="header-title">{{ itemEditButton===undefined ? "Add" : "Edit" }} project</span>
    </div>

    <div class="card" :class='{darkTheme: darkTheme}'>
      <div class="card-body scroll">

        <label for="name" class="mt-1">Project name</label>
        <input type="text" id="name" name="projectname" v-model.lazy="project.title" @change="somethingChanged = true" placeholder="Enter project name (required)" class="form-control mb-3">

        <label for="description">Description</label>
        <textarea id="description" rows="3" name="description" v-model.lazy='project.description' @change="somethingChanged = true" placeholder="Enter project description (optional)" class="form-control mb-3" spellcheck="false"></textarea>

        <!-- DEADLINE -->
        <label for="deadline">Deadline</label>
        <div class="form-group mb-0" id='deadline' title='Deadline'>
          <date-picker v-model="project.deadline" type="datetime" lang="en" format="YYYY-MM-DD HH:mm"
          :first-day-of-week="1" :minute-step="5" :not-before="new Date()"
          placeholder="Pick a deadline (optional)" confirm-text="Confirm"
          @change="dateInputChange" @input-error="dateInputErr" confirm></date-picker>
        </div>
        <small v-if="dateErr" class="text-danger">Deadline can't be in the past.</small>

        <!-- TAGS -->
        <label for="tags" class="mt-3">Tags</label>
        <div class="form-group mb-0" id='deadline' title='Tags'>
          <multiselect
            v-model="selectedTags"
            :options="projectTags"
            id="tags-component"
            :multiple="true"
            :close-on-select="true"
            :clear-on-select="true"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Add tags (optional)"
            label="tag_text"
            track-by="tag_text"
            :preselect-first="true"
            :show-no-results="false"
            open-direction="top"
            :maxHeight="200"
            @select="somethingChanged = true"
            @tag="addTag"
            :taggable="true">
          </multiselect>
        </div>




        <div id="users" class="mt-3">
          <label for="users">Manage users on this project</label>

          <b-input-group @keyup.enter="submitEmail(); somethingChanged = true">
            <b-form-input v-model="email" ref="focusThis" placeholder="Type email to add new user" />
            <b-input-group-append>
              <b-btn :disabled="isInvalidEmail || isDoubleEmail" @click="submitEmail(); somethingChanged = true">Submit</b-btn>
            </b-input-group-append>
          </b-input-group>
          <div class='user-table'>
            <b-table :items='project.users' :fields='usersField' responsive hover :dark='darkTheme' v-if="this.project.users.length > 0">

              <template slot="email" slot-scope="row">
                <span class="badge badge-warning" v-if="project.users[row.index].new === true">New</span>
                {{project.users[row.index].email}}

              </template>

              <template slot="admin" slot-scope="row">
                <b-form-checkbox @click.native.stop @change="changeAdmin(row.index)" :checked="project.users[row.index].admin" :disabled="!project.users[row.index].disabled"></b-form-checkbox>
              </template>

              <template slot="remove" slot-scope="row">

                <button type="button" class="btn btn-danger btn-sm" @click="changeDeleted(row.index)" v-if="project.users[row.index].isyou === 'false' && (project.youAreCreator === 'true' || project.users[row.index].canEdit === true)">
                  <span class="fa fa-times"></span>
                </button>
              </template>
            </b-table>
          </div>
        </div>

        <div class='project-action float-right'>
          <button @click="projectCancel" @keydown.enter.prevent class="btn btn-danger" id="cancel">
            <span class="fa fa-ban"></span> Cancel</button>

          <button v-if='itemEditButton!==undefined' @click="projectEdit" class="btn btn-primary" :disabled='blankTitle || waitNet'>
            <span class="fa fa-save"></span> Save changes</button>

          <button v-else @click="projectCreate" class="btn btn-success" :disabled='blankTitle || waitNet'>
            <span class="fa fa-plus-square"></span> Create project</button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

import { api } from "@/api/index.js";
import { store } from "@/store/index.js";
import { mapGetters, mapState } from "vuex";
import { routejs } from "@/router/routemanage.js";
export default {
  components: {
    DatePicker,
    Multiselect
  },
  data() {
    return {
      dateErr: false,
      selectedTags: [],
      projectTags: [],

      UserID: undefined,
      somethingChanged: false,

      project: {
        title: undefined,
        description: undefined,
        users_count: undefined,
        deadline: undefined,
        users: []
      },
      config: {
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
        altFormat: "j M, Y H:i",
        altInput: true,
        minDate: "today"
      },
      usersField: [
        {
          email: {}
        },
        {
          name: {}
        },
        {
          surname: {}
        },
        {
          admin: {}
        },
        {
          remove: {
            thClass: "text-center",
            tdClass: "text-center"
          }
        }
      ],
      email: undefined,
      isAdmin: false,
      waitNet: false
    };
  },
  computed: {
    blankTitle() {
      return !this.project.title || this.project.title === 0;
    },
    usersWorking() {
      let arrayOfUsers = [];

      if (this.project.users !== undefined) {
        for (let i = 0; i < this.project.users.length; i++) {
          if (this.project.users[i].delete === false) {
            let singleUser = {
              email: this.project.users[i].email,
              admin: "" + this.project.users[i].admin + "",
              delete: "false"
            };
            arrayOfUsers.push(singleUser);
          }
        }

        if (this.email !== undefined) {
          let singleUser = {
            email: this.email,
            admin: "false",
            delete: "false"
          };
          arrayOfUsers.push(singleUser);
        }
      }

      return JSON.stringify(arrayOfUsers);
    },
    isInvalidEmail() {
      let email = this.email;
      if (!email) return true;
      let pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let check = email.match(pattern);
      return !check;
    },
    isDoubleEmail() {
      let email = this.email;
      for (let u of this.project.users) {
        if (email === u.email) {
          return true;
        }
      }
      return false;
    },
    usersString: {
      get() {
        let users = this.project.users;
        if (users) {
          let tempUsers = [];
          for (let i = 0; i < users.length; i++) {
            tempUsers.push({
              email: users[i].email,
              admin: "" + this.project.users[i].admin + ""
            });
          }
          return JSON.stringify(tempUsers);
        }
        return undefined;
      },
      set(val) {}
    },
    ...mapGetters({
      currentTabData: "currentTabData"
    }),
    ...mapState({
      darkTheme: "darkTheme",
      tabIndex: "currentTabIndex",
      itemEditButton: state => state.itemAction.edit
    })
  },
  watch: {
    itemEditButton(val) {
      if (!val) {
        this.project.title = undefined;
        this.project.description = undefined;
        this.project.deadline = undefined;
        this.project.users = [];
        this.selectedTags = [];
      } else {
        this.getProjectInfo();
      }
    }
  },
  mounted() {
    if (this.itemEditButton !== undefined) {
      this.getProjectInfo();
    }
  },
  methods: {
    addTag(newTag) {
      const tag = {
        tag_text: newTag
      };
      this.selectedTags.push(tag);
    },

    dateInputChange() {
      this.somethingChanged = true;
      this.dateErr = false;
    },

    dateInputErr() {
      this.dateErr = true;
      this.project.deadline = undefined;
    },
    async changeDeleted(rowIndex) {
      const options = {
        title: "Confirm?",
        okLabel: "Keep",
        cancelLabel: "Delete",
        size: "sm"
      };
      let res = await this.$dialogs.confirm(
        "Are you sure you want to delete this user? Think twice!",
        options
      );
      if (!res) return;
      if (res.ok === false) {
        this.project.users[rowIndex].delete = !this.project.users[rowIndex]
          .delete;
        this.project.users.splice(rowIndex, 1);
      }
    },
    changeAdmin(rowIndex) {
      this.project.users[rowIndex].admin = !this.project.users[rowIndex].admin;
    },

    submitEmail() {
      if (this.isDoubleEmail) return;
      let user = {
        email: this.email,
        admin: false,
        new: true,
        disabled: true,
        canEdit: true,
        isyou: "false",
        delete: false
      };

      this.project.users.push(user);
      this.email = "";
    },
    setupInfo() {
      for (var i = 0; i < this.currentTabData.length; i++) {
        var ctd = this.currentTabData[i];
        if (this.itemEditButton === ctd.id) {
          // PASS BY VALUE, NOT BY REF - DON'T CHANGE
          this.project.title = ctd.title;
          this.project.deadline = this.utcToLocal(ctd.deadline);
          this.project.users_count = ctd.users_count;
        }
      }
    },
    getProjectInfo() {
      api.getProjectInfo(store.getters.selectedItemID).then(result => {
        if (result.data.status === "OK") {
          let moreInfo = result.data.data;

          for (var i = 0; i < moreInfo.tags.length; i++) {
            let tag = {
              tag_text: moreInfo.tags[i].tag_text
            };
            this.selectedTags.push(tag);
          }

          for (var i = 0; i < moreInfo.users.length; i++) {
            moreInfo.users[i].delete = false;
            moreInfo.users[i].admin = moreInfo.users[i].admin === "true";

            if (moreInfo.users[i].admin === false) {
              moreInfo.users[i].canEdit = true;
            }

            if (
              moreInfo.users[i].isyou === "false" &&
              (moreInfo.youAreCreator === "true" ||
                moreInfo.users[i].canEdit === true)
            ) {
              moreInfo.users[i].disabled = true;
            }
          }

          if (moreInfo.length !== 0) {
            this.project = moreInfo;
          }
          this.setupInfo();
        } else {
          store.commit("toastStatus", {
            ok: false,
            message: "Error: Couldn't get project info"
          });
        }
      });
    },
    // CREATING PROJECT
    async projectCreate() {
      this.waitNet = true;
      var tagarray = this.selectedTags.map(e => e.tag_text);
      try {
        let res = await api.createProject(
          this.project,
          this.localToUTC(this.project.deadline),
          this.usersString,
          tagarray
        );

        if (!res) return;
        store.commit("itemActionReset");

        if (res.data.status === "OK") {
          store.commit("incDirtyCounter");
          store.commit("toastStatus", {
            active: true,
            ok: true,
            message:
              "Project '" +
              this.project.title +
              "' has been created succesfully"
          });

          let errors = res.data.data.errors;
          if (errors.length > 0) {
            for (var i = 0; i < errors.length; i++) {
              this.$toasted.show(errors[i], {
                position: "bottom-right",
                duration: 8000,
                className: "alert-danger",
                icon: {
                  name: "exclamation-triangle"
                },
                action: {
                  class: "fas fa-times",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  }
                }
              });
            }
          }
        } else {
          store.commit("toastStatus", {
            ok: false,
            message: "Error: Couldn't create project '" + this.project.title
          });
        }
      } catch (e) {
        return routejs.checkSession(e.response);
      } finally {
        this.waitNet = false;
      }
    },
    async projectEdit() {
      var tagarray = this.selectedTags.map(e => e.tag_text);
      try {
        let res = await api.editProject(
          this.project,
          this.localToUTC(this.project.deadline),
          this.usersString,
          store.getters.selectedItemID,
          tagarray
        );

        if (!res) return;
        if (res.data.status === "OK") {
          store.commit("itemActionReset");
          store.commit("toastStatus", {
            message:
              "Project '" + this.project.title + "' has been edited succesfully"
          });

          //Ako postoje mejlovi koji nisu u sistemu
          let errors = res.data.data.errors;
          if (errors.length > 0) {
            for (var i = 0; i < errors.length; i++) {
              this.$toasted.show(errors[i], {
                position: "bottom-right",
                duration: 8000,
                className: "alert-danger",
                icon: {
                  name: "exclamation-triangle"
                },
                action: {
                  class: "fas fa-times",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  }
                }
              });
            }
          }

          store.commit("incDirtyCounter");
        } else {
          store.commit("toastStatus", {
            ok: false,
            message: `Error: Couldn't edit project '${this.project.title}'`
          });
        }
      } catch (e) {
        return routejs.checkSession(e.response);
      }
    },
    async projectCancel() {
      if (this.somethingChanged === true) {
        const options = {
          title: "Confirm?",
          okLabel: "Stay on page",
          cancelLabel: "Leave",
          size: "sm"
        };
        let res = await this.$dialogs.confirm(
          "Are you sure you want to leave? You might have unsaved changes!",
          options
        );

        if (res.ok === false) store.dispatch("resetGlobalView");
      } else store.dispatch("resetGlobalView");
    },
    CustomPersonLabel(option) {
      return `${option.email}`;
    },
    focusMyElement(e) {
      this.$refs.focusThis.focus();
    }
  }
};
</script>

<style scoped>
.pro-edit {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.emailDark {
  background: #2d3436;
  color: #fff;
}

.header {
  position: absolute;
  user-select: none;
  position: relative;
  width: 150px;
  bottom: 30px;
  text-align: center;
  color: var(--ac-color);
  font-size: 1rem;
  margin: 0 auto;
}

.header * {
  margin: 0;
}

.header-title {
  border-bottom: 2px solid;
  padding: 0 10px 5px 10px;
  font-weight: bold;
}

#users {
  width: 100% !important;
  margin-bottom: 30px;
}

.input-group {
  margin-bottom: 20px;
}

.btn-success {
  color: white;
}

h4 {
  color: white;
}

.project-action {
  margin-left: auto;
}

.project-action .fa {
  margin-right: 10px;
}

.project-action button {
  margin-left: 10px;
  /* right: 0; */
}

.scroll {
  overflow: auto;
  min-height: 80vh;
  max-height: 85vh;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css">



// WEBPACK FOOTER //
// src/components/Content/Project/ProjectManage.vue